module.exports = __webpack_public_path__ + "static/Website-Devices.a68c06dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/media/website/assets/Website-Devices.png
// module id = 282
// module chunks = 35783957827783